export class ProductService {
  constructor(context) {
    this.context = context;
    this.axios = this.context.$axios;
  }
  async getProductGeneralStats(
    productId,
    suscriberId,
    toDate,
    fromDate,
    businessUnitId,
    bookCode,
    commercialName
  ) {
    try {
      const URL_PORTAL = `${process.env.VUE_APP_API_BASE_URL}/portal-stats/${productId}/subscribers/${suscriberId}/businesses/${businessUnitId}?toDate=${toDate}&fromDate=${fromDate}&BookCode=${bookCode}&commercialName=${commercialName}`;
      const product = await this.axios.get(URL_PORTAL);
      return product.data;
    } catch (err) {
      console.log(`la peticion fallo :${err}`);
    }
  }

  async getCategoryStats(subscriberId, productId, toDate, fromDate) {
    try {
      const categories = await this.axios.get(
        `${
          process.env.VUE_APP_API_BASE_URL
        }/portal-stats/${productId}/subscribers/${subscriberId}/businesses/${localStorage.getItem(
          "businessUnitId"
        )}/categories?toDate=${toDate}&fromDate=${fromDate}`
      );
      return categories.data;
    } catch (err) {
      console.log(`la peticion fallo: ${err}`);
    }
  }
}
